import { memo } from "react";
import type { GoldenSerenityTemplateProps } from "./types";
import { GS, isRsvpCutoffPassed } from "./utils";

export const GoldenSerenityNavbar = memo(({ event, config, t, onRsvpClick }: GoldenSerenityTemplateProps) => {
  const coupleNames =
    event.starBride && event.starGroom
      ? { first: event.starBride, second: event.starGroom }
      : null;
  const rsvpVisible = Boolean(event.rsvpSettings?.rsvpEnabled) && !isRsvpCutoffPassed(event);

  // The top offset includes the owner's draft-preview banner height (JUB-154,
  // PREVIEW_OFFSET_VAR in @/lib/previewBannerOffset); Tailwind needs the literal name.
  // z-40 keeps it below the dialog layer (z-50) so it never covers the RSVP dialog.
  return (
    <nav className="fixed top-[calc(var(--jb-preview-offset,0px)+1rem)] sm:top-[calc(var(--jb-preview-offset,0px)+2rem)] left-1/2 -translate-x-1/2 z-40 w-[92%] max-w-5xl">
      <div
        className="backdrop-blur-md rounded-full px-5 sm:px-10 py-3 sm:py-4 flex items-center justify-between gap-3 border"
        style={{
          background: "rgba(253,248,243,0.95)",
          borderColor: "rgba(232,220,200,0.4)",
          boxShadow: "0 4px 24px rgba(196,154,108,0.12)",
        }}
      >
        <a
          href="#home"
          className="min-w-0 truncate text-lg sm:text-2xl font-medium tracking-wide"
          style={{ color: config.palette.text, fontFamily: config.typography.heading }}
        >
          {coupleNames ? (
            <>
              {coupleNames.first} <span style={{ color: GS.sage }}>&</span> {coupleNames.second}
            </>
          ) : (
            event.name
          )}
        </a>

        {rsvpVisible && (
          <button
            type="button"
            onClick={onRsvpClick}
            className="shrink-0 px-4 sm:px-8 py-2 sm:py-2.5 rounded-full font-semibold text-xs sm:text-sm tracking-wide transition-all duration-500 hover:shadow-[0_4px_16px_rgba(201,168,106,0.3)]"
            style={{
              background: GS.gold,
              // JUB-90: creamLight-on-gold was 2.1:1 (fails WCAG AA); GS.ink gives ~5.7:1
              color: GS.ink,
              fontFamily: config.typography.body,
            }}
          >
            {t("events.form.template.rsvp")}
          </button>
        )}
      </div>
    </nav>
  );
});

GoldenSerenityNavbar.displayName = "GoldenSerenityNavbar";
